import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import i18n from '../../i18n';
import initializeEcho from '../../utils/echo';
import api from '../../utils/api';
import { Bell, User, LogOut, Globe, Home } from 'lucide-react';

export default function TechnicienLayout({isHome , refresh } : {isHome : Boolean , refresh : ()=>void}) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [pendingReservations, setPendingReservations] = useState(0);
  const [echo, setEcho] = useState(null);
  const [showLangMenu, setShowLangMenu] = useState(false);
  
  const getReservations = () => {
    return pendingReservations;
  };
  
  const languages = [
    { label: 'English', value: 'en' },
    { label: 'Français', value: 'fr' },
    { label: 'العربية', value: 'ar' },
  ];
  
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('userLanguage', lng);
    setShowLangMenu(false);
  };
 
  useEffect(() => {
    if (!echo) {
      fetchPendingReservations();
      const setupEcho = async () => {
        const echoInstance = await initializeEcho();
        setEcho(echoInstance);
      };
      setupEcho();
    }
    return () => {
      if (echo) {
        // echo.disconnect();
      }
    };
  }, [echo]);
  
  useEffect(() => {
    if (echo) {

      const channelName = `dashboard_notification`;
      const channel = echo.private(channelName);
     
      const newReservationHandler = async (data) => {
        await fetchPendingReservations();
        refresh();
        if ("Notification" in window) {
          Notification.requestPermission().then(permission => {
            if (permission === "granted") {
              const notif = new Notification(t('notif_new_reservation'), {
                body: t('notif_new_reservation_body'),
                icon: "/icon.png"  
              });
     
              notif.onclick = () => {
                window.focus();
                navigate('/reservations');
              };
            }
          });
        }
      };
     
      // Register listeners
      channel.listen('.new.reservation.accepted', newReservationHandler);
      console.log(channel);
 
      // Cleanup function
      return () => {
        channel.stopListening('.new.reservation.accepted', newReservationHandler);
      };
    }
  }, [echo, navigate, t]);
 
  const fetchPendingReservations = async () => {
    try {
      const response = await api.get('technicien/service-reservations/pending/count');
      setPendingReservations(response.data);
    } catch (error) {
      console.error('Error fetching pending orders:', error);
    }
  };
 
  return (
    <header className="flex justify-between items-center bg-white text-gray-800 p-4 w-full shadow-md">
      <div className="logo-container">
      <img   src="/images/logo.png"  className='h-12'/>
      </div>
      
      <div className="flex gap-4 items-center">
        <div className="relative">
          <button 
            className="p-2 rounded-full hover:bg-gray-100"
            onClick={() => setShowLangMenu(!showLangMenu)}
          >
            <Globe size={20} />
          </button>
          
          {showLangMenu && (
            <div className="absolute right-0 mt-2 bg-white border rounded-md shadow-lg z-10">
              {languages.map((lang) => (
                <button
                  key={lang.value}
                  onClick={() => changeLanguage(lang.value)}
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                >
                  {lang.label}
                </button>
              ))}
            </div>
          )}
        </div>
        
        <button className="p-2 rounded-full hover:bg-gray-100 relative">
          <Bell size={20} />
          {pendingReservations > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              {pendingReservations}
            </span>
          )}
        </button>
        {isHome ? 
      
        <a href='/profile' className="p-2 rounded-full hover:bg-gray-100">
       <User size={20} />
     </a> : 
        <a href='/' className="p-2 rounded-full hover:bg-gray-100">
        <Home size={20} />
      </a> }
       
        
        <button onClick={logout} className="p-2 rounded-full hover:bg-gray-100">
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
}